import React, { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Axios from "../../axios/axios";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

// export default function Login() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [searchParams] = useSearchParams();
//   const redirect = searchParams.get('redirect') || '/';
//   const [showPassword, setShowPassword] = useState(false);
//   const [userType, setUserType] = useState('customer');

//  const handleLogin = async (e) => {
//   e.preventDefault();
//   try {
//     const endpoint = userType === 'customer' ? 'customer/login' : 'supplier/login';
//     const response = await Axios.post(endpoint, { email, password });

//     if (userType === 'customer') {
//       const userInfo = {
//         token: response.data.token,
//         username: response.data.username,
//         customerId: response.data.customerId,
//       };
//       sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
//       navigate(redirect, { replace: true });
//     } else {
//       const supplierInfo = {
//         token: response.data.token,
//         username: response.data.username,
//         supplierId: response.data.supplierId,
//          productCategory: response.data.productCategory || response.data.category || null,

//       };
//       sessionStorage.setItem('supplierInfo', JSON.stringify(supplierInfo));
//       console.log(supplierInfo);

//       navigate('/SupplierDashboard');
//     }

//     window.location.reload();
//   } catch (err) {
//     setError('Invalid credentials. Please try again.');
//   }
// };

//   return (
//     <div>
//       <Header />
//       <section id="login">
//         <div className="container" style={{ marginTop: '150px' }}>
//           <div className="col-md-6 offset-md-3">
//             <h3>Login</h3>
//             <p>
//               From its medieval origins to the digital era, learn everything
//               there is to know about the ubiquitous lorem ipsum passage.
//             </p>

//             <div className="col-md-10 offset-md-1 login_form">
//               {error && (
//                 <p className="error" style={{ color: 'red' }}>
//                   {error}
//                 </p>
//               )}
//               <div className="form-group">
//   <label>Login as:</label>
//   <div>
//     <label>
//       <input
//         type="radio"
//         value="customer"
//         checked={userType === 'customer'}
//         onChange={() => setUserType('customer')}
//       />
//       Customer
//     </label>
//     <label style={{ marginLeft: '20px' }}>
//       <input
//         type="radio"
//         value="supplier"
//         checked={userType === 'supplier'}
//         onChange={() => setUserType('supplier')}
//       />
//       Supplier
//     </label>
//   </div>
// </div>

//               <form onSubmit={handleLogin}>
//                 <div className="form-group">
//                   <label htmlFor="inputEmail">Email*</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                   />
//                 </div>
//                 <div className="form-group password_form">
//   <label htmlFor="inputPassword">Password*</label>
//   <div className="passwordtext" style={{ position: 'relative' }}>
//     <input
//       type={showPassword ? 'text' : 'password'}
//       className="pass_textarea form-control"
//       value={password}
//       onChange={(e) => setPassword(e.target.value)}
//       required
//     />
//     <span
//       onClick={() => setShowPassword((prev) => !prev)}
//       style={{
//         position: 'absolute',
//         right: '10px',
//         top: '50%',
//         transform: 'translateY(-50%)',
//         cursor: 'pointer',
//       }}
//     >
//       {showPassword ? <FaEye FaEyeSlash size={20} /> : <FaEyeSlash size={20} />}
//     </span>
//   </div>
//   <a href="/forgot" className="forgotPassword">
//     Forgot password
//   </a>
// </div>

//                 <div className="my-5">
//                   <button type="submit" className="loginButton login_btn">
//                     Login
//                   </button>
//                 </div>
//               </form>
//               <p className="dontHaveAccount">Don’t have an account?</p>
//               <div>
//   <Link to="/signup" className="signupButton">
//     Signup
//   </Link>
// </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// }
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "/";
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await Axios.post("customer/login", { email, password });

      const userInfo = {
        token: response.data.token,
        username: response.data.username,
        customerId: response.data.customerId,
      };

      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      navigate(redirect, { replace: true });
      window.location.reload();
    } catch (err) {
      setError("Invalid credentials. Please try again.");
    }
  };
  // const [userType, setUserType] = useState('customer');

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const endpoint = userType === 'customer' ? 'customer/login' : 'supplier/login';
  //     const response = await Axios.post(endpoint, { email, password });

  //     if (userType === 'customer') {
  //       const userInfo = {
  //         token: response.data.token,
  //         username: response.data.username,
  //         customerId: response.data.customerId,
  //       };
  //       sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
  //       navigate(redirect, { replace: true });
  //     } else {
  //       const supplierInfo = {
  //         token: response.data.token,
  //         username: response.data.username,
  //         supplierId: response.data.supplierId,
  //         productCategory: response.data.productCategory || response.data.category || null,
  //       };
  //       sessionStorage.setItem('supplierInfo', JSON.stringify(supplierInfo));
  //       console.log(supplierInfo);
  //       navigate('/SupplierDashboard');
  //     }

  //     window.location.reload();
  //   } catch (err) {
  //     setError('Invalid credentials. Please try again.');
  //   }
  // };

  return (
    <div className="Main-div">
      {/* <Header /> */}
      <TopNavBar />
      <div className="TopSearchBar">
        <TopSearchBar />
      </div>
      <section id="login">
        <div className="container">
          <div className="col-md-6 offset-md-3">
            <h3>Customer Login</h3>
            <p>
              From its medieval origins to the digital era, learn everything
              there is to know about the ubiquitous lorem ipsum passage.
            </p>

            <div className="col-md-10 offset-md-1 login_form">
              {error && (
                <p className="error" style={{ color: "red" }}>
                  {error}
                </p>
              )}

              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label htmlFor="inputEmail">Email*</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group password_form">
                  <label htmlFor="inputPassword">Password*</label>
                  <div
                    className="passwordtext"
                    style={{ position: "relative" }}
                  >
                    <input
                      type={showPassword ? "text" : "password"}
                      className="pass_textarea form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? (
                        <FaEye size={20} />
                      ) : (
                        <FaEyeSlash size={20} />
                      )}
                    </span>
                  </div>
                  <a href="/forgot" className="forgotPassword">
                    Forgot password
                  </a>
                </div>

                <div className="my-5">
                  <button type="submit" className="loginButton login_btn">
                    Login
                  </button>
                </div>
              </form>

              {/* Add this link for customer login redirect */}
              <div style={{ marginTop: "10px" }}>
                <Link to="/login-supplier" className="customer-login-link">
                  Login as Supplier?
                </Link>
              </div>

              <p className="dontHaveAccount">Don't have an account?</p>
              <div>
                <Link to="/signup" className="signupButton">
                  Signup
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </div>
  );
}
